module.exports = __webpack_public_path__ + "static/media/cupid-deluxe.42e092fd.jpg";